import { ActionTypes } from "../constants";

const updateModuleEnrolment = (state, moduleId, enrolment = {}) => {
    const courses = state.filter(({modules}) => modules.map(({id}) => id).includes(moduleId));
    const courseIds = courses.map(({id}) => id);
    const updateModules = (modules) => {
        const updatedModule = modules.find(({id}) => id === moduleId);
        return [
            ...modules.filter(({id}) => id !== moduleId),
            {
                ...updatedModule,
                enrolment: {
                    ...updatedModule.enrolment,
                    ...enrolment
                }
            }
        ];
    };

    return [
        ...state.filter(({id}) => !(courseIds.includes(id))),
        ...courses.map((course) => ({
            ...course,
            modules: updateModules(course.modules)
        }))
    ];
};


const reduceCourses = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_TMS_COURSES_SUCCESS:
            return action.data;

        case ActionTypes.GET_TMS_COURSE_DETAILS_SUCCESS:
        case ActionTypes.ADD_TMS_ENROLMENT_SUCCESS:
        case ActionTypes.UPDATE_TMS_ENROLMENT_SUCCESS:
        case ActionTypes.DELETE_TMS_ENROLMENT_SUCCESS:
            return [
                ...!state ? [] : state.filter(({id}) => id !== action.data.id),
                action.data
            ];

        case ActionTypes.UPDATE_TMS_MODULE_ENROLMENT_SUCCESS:
            if (!state) { return state; }
            return updateModuleEnrolment(state, action.payload.id, action.payload.params);

        case ActionTypes.ADD_TMS_EVENT_BOOKING_SUCCESS:
            if (!state) { return state; }
            const event = {
                id: action.payload.eventId,
                dateStart: action.payload.eventDate,
                attendance: {
                    'id': action.data.id,
                    'status': action.data.status,
                    'canCancel': true
                }
            };
            return updateModuleEnrolment(state, action.payload.moduleId, {event});

        case ActionTypes.DELETE_TMS_EVENT_BOOKING_SUCCESS:
            if (!state) { return state; }
            return updateModuleEnrolment(state, action.payload.moduleId, {event: null});

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getCourse = (courses, courseId) => !courses ? null :  courses.find(({id}) => id === courseId);
export const getByCategory = (courses, categoryId) => !courses ? null : courses.filter(({category}) => !!category && category.id === categoryId);
export const getByEnrolments = (courses) => !courses ? null : courses.filter(({enrolment}) => !!enrolment && !!enrolment.id);

export default reduceCourses;
